module.exports = __webpack_public_path__ + "img/content2.f4b6737e.png";